'use strict';

require('backbone.stickit');
require('backbone-validation');
const _ = require('underscore');
const Mn = require('backbone.marionette');
const Template = require('process/ui/template/action/state-edit.hbs');

module.exports = Mn.View.extend({
    template: Template,
    bindings: {
        'select.state': {
            observe: 'state',
            selectOptions: {
                collection: function() {
                    if(!this.model.getType()) {
                        return [];
                    }
                    return _.map(this.model.getType().getStates(), s => {
                        return {
                            id: s.id,
                            name: s.getName()
                        }
                    });
                },
                labelPath: 'name',
                valuePath: 'id'
            }
        }
    },
    modelEvents: {
        'change': 'modelChange'
    },

    initialize: function() {
        this.model = this.model.clone();
    },

    templateContext: function() {
        return {
            type: this.model.getType()
        }
    },

    onRender: function() {
        Backbone.Validation.bind(this, {
            selector: 'class'
        });

        this.stickit();

        return this;
    },

    validate: function() {
        if(!this.model.isValid(true)) {
            return false;
        }
        return true;
    },

    getJSON: function() {
        const json = {
            state: this.model.get('state')
        };
        return json;
    },
    modelChange: function() {
        this.trigger('change:actionState');
    }
});



// WEBPACK FOOTER //
// ./process/ui/view/action/state-edit.js